'use client';
import React from 'react';
import { usePathname, useRouter } from 'next/navigation';
import auth from '@/utils/auth';

type Props = { children: React.ReactNode; initialServerAuth?: boolean };

// Client-side guard: if not authenticated, redirect to /login.
export function RequireAuth({ children, initialServerAuth }: Props) {
  const pathname = usePathname();
  const router = useRouter();

  React.useEffect(() => {
    // Public routes that don't need auth
    if (!pathname) {
      return;
    }
    const publicPrefixes = ['/login', '/legal', '/_next', '/api'];
    const isPublic = publicPrefixes.some((p) => pathname.startsWith(p));
    if (isPublic) {
      return;
    }

    const ok = typeof window !== 'undefined' ? auth.isAuthenticated() : !!initialServerAuth;
    if (!ok) {
      // redirect to login, preserving attempted path as query param
      const encoded = encodeURIComponent(pathname);
      router.replace(`/login?next=${encoded}`);
    }
  }, [pathname, router]);

  return <>{children}</>;
}

export default RequireAuth;
